import React, { useState } from "react";

const rightArrowIcon = require("assets/img/icons/right-arrow.png");

// Cada bloque de la pantalla es uno de los reportes que alimentan el
// comparativo. La descripción dice qué columnas del cuadro final salen de ahí,
// que es a lo que se viene a esta pantalla.
// Las secciones colapsables arrancan cerradas: son las fuentes, y se abren
// cuando hay que revisar de dónde salió una cifra del cuadro final
export const SeccionReporte = ({
    titulo,
    descripcion,
    colapsable,
    children,
}) => {
    const [abierta, setAbierta] = useState(false);

    const mostrarContenido = !colapsable || abierta;

    const encabezado = (
        <div
            className={
                colapsable ? "comparativo-mensual__seccion-header" : ""
            }
            onClick={colapsable ? () => setAbierta(!abierta) : undefined}
        >
            <h5 className="comparativo-mensual__seccion-titulo d-flex align-items-center">
                {colapsable && (
                    <img
                        src={rightArrowIcon}
                        alt={abierta ? "Ocultar" : "Mostrar"}
                        className="action_img expand-icon mr-2"
                        style={{ width: "14px", height: "14px" }}
                    />
                )}
                {titulo}
            </h5>

            {descripcion && (
                <p className="comparativo-mensual__seccion-descripcion">
                    {descripcion}
                </p>
            )}
        </div>
    );

    return (
        <div
            className={`comparativo-mensual__seccion ${
                abierta ? "expanded" : ""
            }`}
        >
            {encabezado}

            {mostrarContenido && children}
        </div>
    );
};
